import AuditTrailTemplate from "components/lib/Shared/AuditTrailTemplate";
import React from "react";
import { useSelector } from "react-redux";

/**
 * AuditTrail component displays the audit trail of the e-signature process for a company official.
 * It retrieves the latest envelope from the official's row data and passes it to the AuditTrailTemplate for rendering.
 * @param {*} param0 - The props object
 * @returns
 */
const AuditTrail = ({ row }) => {
  // Get the latest envelope from the official's row data
  const envelopes = [row.original.envelopes[row.original.envelopes.length - 1]];

  if (envelopes?.length > 0) {
    return (
      <div>
        <AuditTrailTemplate envelopes={envelopes} />
      </div>
    );
  } else {
    return (
      <div>
        <h2>getting envelopes...</h2>
      </div>
    );
  }
};

export default AuditTrail;
